import {api} from 'api/setup';
import {ICategoryResponse} from 'types';

const BASE_PATH = 'categories';

export const getCategoryByRestaurant = (locale?: string): Promise<ICategoryResponse[]> => {
  return api.get(`/${BASE_PATH}/restaurant`, {
    headers: locale ? {'Accept-Language': locale} : undefined,
  });
};

export const getCategoryByMarkets = (locale?: string): Promise<ICategoryResponse[]> => {
  return api.get(`/${BASE_PATH}/market`, {
    headers: locale ? {'Accept-Language': locale} : undefined,
  });
};
